const destroyFns: Array<Function> = [];
export default destroyFns;
